// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.afQ92d6OgPQhiOnTAOQN {
  color: var(--footer-copyright-text-color);
  font-family: var(--body-font-family);
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.5rem;
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/FooterCopyright/FooterCopyright.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,oCAAoC;EACpC,gBAAgB;EAChB,mBAAe;EACf,mBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".footerCopyright {\n  color: var(--footer-copyright-text-color);\n  font-family: var(--body-font-family);\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 24px;\n  text-transform: uppercase;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerCopyright": `afQ92d6OgPQhiOnTAOQN`
};
export default ___CSS_LOADER_EXPORT___;
